import React, { useRef, useState, useEffect } from 'react';

import { Wrapper, Content, Iframe } from './WidgetIframe.style';

function WidgetIframe({ data = {} }) {
  const ref = useRef(null);
  const [nativeIframeWidth, setNativeIframeWidth] = useState(undefined);
  const [nativeIframeHeight, setNativeIframeHeight] = useState(undefined);
  const [iframeWidth, setIframeWidth] = useState(undefined);
  const [iframeHeight, setIframeHeight] = useState(undefined);

  useEffect(() => {
    if (ref && ref.current) {
      setNativeIframeWidth(
        data.width ? parseInt(data.width) : parseInt(ref.current.clientWidth)
      );
      setNativeIframeHeight(
        data.height ? parseInt(data.height) : parseInt(ref.current.clientWidth)
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let timeoutTimer;

    function handleResize() {
      if (timeoutTimer) clearTimeout(timeoutTimer);
      timeoutTimer = setTimeout(() => {
        if (ref && ref.current) {
          const clientWidth = parseInt(ref.current.clientWidth);
          setIframeWidth(
            clientWidth > nativeIframeWidth ? nativeIframeWidth : clientWidth
          );
        }
      }, 200);
    }

    window.addEventListener('resize', handleResize);
    return () => {
      if (timeoutTimer) clearTimeout(timeoutTimer);
      window.removeEventListener('resize', handleResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nativeIframeWidth, nativeIframeHeight]);

  useEffect(() => {
    if (nativeIframeWidth && nativeIframeHeight) {
      setIframeWidth(parseInt(nativeIframeWidth));
      setIframeHeight(parseInt(nativeIframeHeight));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nativeIframeWidth, nativeIframeHeight]);

  useEffect(() => {
    setIframeHeight(
      Math.round(nativeIframeHeight / (nativeIframeWidth / iframeWidth))
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [iframeWidth]);

  return (
    <>
      {data.url ? (
        <Wrapper ref={ref}>
          <Content>
            <Iframe
              url={data.url}
              frameborder={data.frameborder || 0}
              scrolling={data.scrolling || 'no'}
              allow={data.allow || 'fullscreen'}
              width={iframeWidth}
              height={iframeHeight}
            />
          </Content>
        </Wrapper>
      ) : (
        ''
      )}
    </>
  );
}

export default WidgetIframe;
